import ProjectSetting from '@/setting/projectSetting';
import { isDevMode } from '@/utils/env';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';


const storageLang = localStorage.getItem('i18nextLng');
export const defaultLocale = storageLang ?? ProjectSetting.APP_DEFAULT_LOCALE;
const missingKeys: any = localStorage.getItem('debug_missingKeys') ?? [];

const languageModules: { [key: string]: () => Promise<any> } = {};

const requireContext = require.context('@/locales', false, /\.json$/);

requireContext.keys().forEach(async (key: string) => {
  const moduleName = key.replace(/(\.\/|\.json)/g, '');
  languageModules[moduleName] = () => import(`@/locales/${moduleName}.json`);
});

const map = {
  'Hi': 'hi',
  'in-IN': 'hi',
  'sv-SE': 'sv',
};
const allTask = Object.keys(languageModules).map(async (key) => {
  const res = await languageModules[key]();
  return { code: map[key] ?? key, data: res?.default };
});


Promise.all(allTask).then(res => {
  const locale = res?.reduce((previousValue, currentValue) => {
    return { ...previousValue, [currentValue.code]: currentValue.data };
  }, {});

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: storageLang?.includes('zh')
        ? 'zh'
        : storageLang ?? defaultLocale,
      interpolation: {
        escapeValue: false,
      },
      lng: defaultLocale,
      resources: locale,
      parseMissingKeyHandler: function(key) {
        return 'undefined'; // 找不到翻译时返回空字符串
      },
      saveMissing: true, // 开启缺失键保存功能
      missingKeyHandler: function(_lngs, _ns, key: any) {
        // 新增：从缓存中获取丢失的键数组
        // 当找不到键时执行的函数
        if (!missingKeys.includes(key)) {
          if (isDevMode()) {
            const saveMissing = localStorage.getItem('saveMissing') ?? 'true';
            if (saveMissing === 'true') {
              // message.info('请处理国际化遗漏 key [ ' + key + ' ]');
            }
            let missingKeysObj: any = {};
            missingKeys.push(key);
            missingKeys?.forEach((element: any) => {
              missingKeysObj[element] = element;
            });

            console.log(
              JSON.stringify(missingKeysObj),
              '国际化配置没有找到键的！！！',
            );
            localStorage.setItem('missingKeys', missingKeys); // 将更新后的数组保存到缓存
          }
        }
      },
    });

});


export default i18n;
